/**
 * @typedef PostNode
 * @property {'public'|'protected'|'private'} privacy  Privacy level of the post. Only public posts can be Boosted
 * @property {'group'|'user'|'webinar'} entry  Type of entry which this Post is associated with
 * @property {object} place
 * @property {AuthenticatedUser} owner Owner (author) of this post
 * @property {boolean} im_participant (?) Is the currently logged in user subscribed to updated for this Post
 * @property {PostRole} participant_role  Role of the currently logged in user in regards to this Post
 */

(function () {
    angular.module('tradersyard').factory('PostsService', postsServiceFactory);

    postsServiceFactory.$inject = ['AuthService'];

    /**
     * REFACTOR: Can be moved to an angular const provider
     * @readonly
     * @enum {string}
     */
    const PostRole = {
        OWNER: 'owner',
        EXECUTIVE: 'executive',
        EMPTY: '',
    };

    function postsServiceFactory(AuthService) {
        /**
         * Roles that indicate administrative privileges for posts
         * @type {string[]}
         */
        const POST_ADMIN_ROLES = [PostRole.OWNER, PostRole.EXECUTIVE];

        return {
            canAdministerPost,
            canBoostPost,
        };

        /**
         * Can currently logged in user administer the given post?
         * @param {PostNode} postNode
         */
        function canAdministerPost(postNode) {
            // Sometimes, the role can be empty, e.g when dealing with personal timelines,
            // as they lack any participation information, we simply check the ownership then
            if (postNode.participant_role === PostRole.EMPTY) {
                return AuthService.getUserId() === postNode.owner.id;
            }

            // if participant_role is there, just see if it's in the allowed list
            return POST_ADMIN_ROLES.includes(postNode.participant_role);
        }

        /**
         * Currently a post can only be boosted by the Owner.
         * @param postNode
         * @return {boolean}
         */
        function canBoostPost(postNode) {
            return AuthService.getUserId() === postNode.owner.id;
        }
    }
})();
